// Empty state. A real icon, a heading, one line of guidance. No emoji, no
// illustration, no decorative rule.
import type { ReactNode } from "react";
import { Icon } from "@traveldiary/ui";

export interface EmptyStateProps {
  glyph: ReactNode;
  title: string;
  hint: string;
  action?: ReactNode;
}

export function EmptyState({ glyph, title, hint, action }: EmptyStateProps) {
  return (
    <div className="empty">
      <Icon size={28} color="var(--color-text-muted)">
        {glyph}
      </Icon>
      <p className="empty-title">{title}</p>
      <p className="empty-hint">{hint}</p>
      {action ? <div className="empty-action">{action}</div> : null}
    </div>
  );
}
